import React from "react";
import { FaCheck } from "react-icons/fa";
import "../styles/Itinerary.css";

const Incluye = ({ incluye }) => {
  return (
    <div className="itinerary-container">
      <ul className="itinerary-list">
        {incluye.map((item, index) => (
          <li key={index} className="itinerary-item">
            <FaCheck className="icon" /> {item}{" "}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Incluye;
